import { FileRow } from 'baseui/file-uploader';
import { IdName } from './app';
import { CurrentState } from './currentState';

export enum DriverStatus {
  recognized = 1,
  unknown,
}

export interface FleetDriverClient {
  client: IdName;
  subClient: IdName;
  assignedAt?: number;
  lastSeenAt?: number;
  lastAssetId?: string;
  label?: string;
  active: boolean;
}

export interface FleetDriver {
  _id: string;
  name: string;
  lastName: string;
  phone?: string;
  email?: string;
  licenseNumber?: string;
  licenseExpiry?: number;
  photo?: string; // S3 url
  clients: FleetDriverClient[];
  createdAt: number;
  updatedAt: number;
}

export interface FleetDriverDetail extends FleetDriver {
  rekognitionFaceId?: string;
  secondaryRekognitionFaceIds?: string[];
  cs?: CurrentState;
}

export interface FleetDriverRequest extends Omit<FleetDriver, '_id' | 'clients' | 'createdAt' | 'updatedAt'> {
  photoFile?: FileRow;
}

export interface UpdateFleetDriverRequest extends Omit<
  FleetDriver,
  '_id' | 'clients' | 'createdAt' | 'updatedAt' | 'photo'
> {}

export enum FleetDriverTab {
  general = 'generales',
  currentState = 'estado-actual',
  photos = 'fotos',
}

export interface GorilaDriver {
  driverId?: string;
  name?: string;
  lastName?: string;
  key?: string;
  detectedKey?: string;
}
